import React, { Component } from "react";

import openGeocoder from "node-open-geocoder";
import { Localized } from "fluent-react/compat";
import SnackBar from "../user/SnackBar";
import CallApi from "../../utils/CallApi";
import PropTypes from "prop-types";
import Button from "./Button";
import Maps from "./Maps";

import "leaflet/dist/leaflet.css";

class Address extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addressId: props.addressId,
      zipCode: props.restaurantAddress.zip_code,
      city: props.restaurantAddress.city,
      street: props.restaurantAddress.street,
      streetNumber: props.restaurantAddress.street_number,
      country: props.restaurantAddress.country,
      additionalAddress: props.restaurantAddress.additional_address,
      lat: props.restaurantAddress.lat,
      long: props.restaurantAddress.long,
      openSnackBar: false,
      success: false,
      errors: "",
      disabled: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (
      props.restaurantId !== state.restaurantId ||
      props.addressId !== state.addressId ||
      props.restaurantAddress.street !== state.street ||
      props.restaurantAddress.street_number !== state.streetNumber ||
      props.restaurantAddress.zip_code !== state.zip_code ||
      props.restaurantAddress.city !== state.city ||
      props.restaurantAddress.country !== state.country ||
      props.restaurantAddress.lat !== state.lat ||
      props.restaurantAddress.long !== state.long ||
      props.restaurantAddress.additional_address !== state.additional_address
    ) {
      return {
        restaurantId: props.restaurantId,
        restaurant: props.restaurant,
        concept: props.concept,
        disabledApp: props.disabledApp,
        emailContact: props.emailContact,
      };
    }

    return null;
  }

  componentDidMount() {
    const { street, zipCode, city, country, lat, long, disabled } = this.state;
    if (street && zipCode && city && country && lat && long && disabled) {
      this.setState({
        disabled: false,
      });
    }
  }

  /**
   * convert long address to coordinates and send new address
   */
  convertAddressToCoordinates = async (longAddress, address) => {
    const result = await this.findAddressByString(longAddress);
    /* if (result && !result.length) {
      this.setState({
        errors: <Localized id="tr-error-input-address" />,
        disabled: true,
      });
    } */
    if (result && result[0] && result[0].lat && result[0].lon) {
      return this.setState({
        lat: result[0].lat,
        long: result[0].lon,
        errors: "",
      });
    }
  };

  handleInputChange = (e) => {
    const { target } = e;
    const { value, name } = target;
    this.setState(
      {
        [name]: value,
      },
      () => this.checkInputsValid()
    );
  };

  handleCoordinates = (lat, long) => {
    let disabled = false;
    this.setState(
      {
        lat,
        long,
        disabled,
      },
      () => {
        this.convertCoordToAddress();
      }
    );
  };

  convertCoordToAddress = async () => {
    const { lat, long } = this.state;
    const result = await this.findAddressByCoord(long, lat);
    if (Object.keys(result).length) {
      this.setState({
        errors: <Localized id="tr-error-message" />,
      });
    }

    if (result && result.address) {
      const {
        town,
        village,
        country,
        house_number,
        postcode,
        pedestrian,
        road,
        city,
      } = result.address;
      this.setState({
        zipCode: postcode,
        city: town || village || city,
        streetNumber: house_number,
        street: pedestrian || road,
        lat,
        long,
        errors: "",
        country,
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const {
      street,
      zipCode,
      city,
      country,
      additionalAddress,
      lat,
      long,
      streetNumber,
    } = this.state;
    const address = {
      update: "address",
      street: street,
      street_number: streetNumber,
      country: country,
      zip_code: zipCode,
      city: city,
      additional_address: additionalAddress,
      lat: lat,
      long: long,
    };
    try {
      CallApi(
        "put",
        "restaurant/admin/info",
        this.state.restaurantId,
        address,
        this.props.token
      );
      this.setState(
        {
          success: true,
          openSnackBar: true,
        },
        () => {
          const {
            street,
            streetNumber,
            country,
            zipCode,
            city,
            additionalAddress,
            lat,
            long,
          } = this.state;
          const address = {
            street,
            streetNumber,
            country,
            zipCode,
            city,
            additionalAddress,
            lat,
            long,
          };
          setTimeout(() => {
            this.props.onUpdateAddress(address);
          }, 2000);
        }
      );
    } catch (e) {
      this.setState({
        errors: <Localized id="tr-error-address" />,
      });
    }
  };

  handleAddress = (address) => {
    if (address && address.suggestion && address.suggestion.latlng) {
      const {
        postcode,
        country,
        county,
        query,
        city,
        name,
      } = address.suggestion;
      const getNumberStreetRegex = /^[0-9]*/;
      const removeWord = /bis|ter/;
      //const { lat, lng } = latlng;
      this.setState(
        {
          city: city,
          street: name
            .replace(getNumberStreetRegex, "")
            .replace(removeWord, ""),
          zipCode: postcode,
          streetNumber: query.match(getNumberStreetRegex),
          country: country,
          county: county,
          disabled: false,
        },
        () => {
          return this.checkAddressExist();
        }
      );
    }
  };

  checkAddressExist = () => {
    const { streetNumber, street, zipCode, city, country } = this.state;
    const longAddress = `${streetNumber} ${street} ${zipCode} ${city} ${country}`;
    this.convertAddressToCoordinates(longAddress);
  };

  handleCloseSnack = () => {
    this.setState({ openSnackBar: !this.state.openSnackBar });
  };

  checkInputsValid = () => {
    const { street, zipCode, city, country } = this.state;

    const check = street && zipCode && city && country ? false : true;
    this.setState({ disabled: check });
  };

  findAddressByString = (address) => {
    return new Promise((resolve, reject) => {
      const replaceAddress = address.replace(/  /g, " ");
      openGeocoder()
        .geocode(replaceAddress)
        .end((err, res) => {
          resolve(res);
          reject(err);
        });
    });
  };

  findAddressByCoord = (long, lat) => {
    return new Promise((resolve, reject) => {
      openGeocoder()
        .reverse(long, lat)
        .end((err, res) => {
          resolve(res);
          reject(err);
        });
    });
  };

  render() {
    return (
      <div id="address" className="container">
        <form className="pure-form">
          <div className="pure-u-md-11-24">
            {!this.state.error}
            <div>
              {/* <h3>
                <Localized id="tr-admin-what-address-restaurant" />
              </h3> */}
              {/*  <label>
                <Localized id="tr-admin-form-geoloc" />
              </label>
              <Place
                type="address"
                class="form-control"
                onChange={this.handleAddress}
              /> */}
            </div>
            <div className="pure-u-g">
              <div className="pure-u-sm-3-24">
                <label>N°</label>
                <input
                  type="text"
                  name="streetNumber"
                  value={this.state.streetNumber}
                  onChange={this.handleInputChange}
                  onBlur={this.checkAddressExist}
                />
              </div>
              <div className="pure-u-sm-1-24" />
              <div className="pure-u-sm-20-24">
                <label>
                  <Localized id="tr-admin-form-name-street" />
                </label>
                <input
                  required
                  type="text"
                  name="street"
                  value={this.state.street}
                  onChange={this.handleInputChange}
                  onBlur={this.checkAddressExist}
                />
              </div>
            </div>
            <label>
              <Localized id="tr-admin-form-zip-code" />
            </label>
            <input
              required
              type="text"
              name="zipCode"
              value={this.state.zipCode}
              onChange={this.handleInputChange}
              onBlur={this.checkAddressExist}
            />
            <label>
              <Localized id="tr-admin-form-city" />
            </label>
            <input
              required
              type="text"
              name="city"
              value={this.state.city}
              onChange={this.handleInputChange}
              onBlur={this.checkAddressExist}
            />
            <label>
              <Localized id="tr-admin-form-country" />
            </label>
            <input
              required
              type="text"
              name="country"
              value={this.state.country}
              onChange={this.handleInputChange}
              onBlur={this.checkAddressExist}
            />

            <label>
              <Localized id="tr-admin-form-complement" />
            </label>
            <input
              type="text"
              name="additionalAddress"
              value={this.state.additionalAddress || ""}
              placeholder=""
              onChange={this.handleInputChange}
              onBlur={this.checkAddressExist}
            />
            <div className="submit">
              {!!this.state.success && this.state.openSnackBar ? (
                <SnackBar
                  open={this.state.openSnackBar}
                  handleCloseSnack={this.handleCloseSnack}
                  text={<Localized id="tr-admin-change" />}
                  success={true}
                />
              ) : (
                ""
              )}
              {this.state.errors ? (
                <p className="error">{this.state.errors}</p>
              ) : (
                ""
              )}
              <Button
                disabledSubmit={this.state.disabled}
                submit={this.handleSubmit}
                text={"tr-button-validate"}
                classCusto={"is-red"}
              />
            </div>
          </div>
          <div className="pure-u-md-2-24" />
          <div className="pure-u-md-10-24" id="container">
            <Maps
              handleCoordinates={this.handleCoordinates}
              lat={this.state.lat ? this.state.lat : 0}
              long={this.state.long ? this.state.long : 0}
              moveMarker={false}
            />
            <p className="info">
              <Localized id="tr-admin-longitude" />
              {this.state.long} / <Localized id="tr-admin-latitude" />{" "}
              {this.state.lat}
            </p>
          </div>
        </form>
      </div>
    );
  }

  static defaultProps = {
    restaurantId: "1",
    addressId: "2",
    zipCode: "",
    city: "",
    street: "",
    streetNumber: "",
    country: "",
    additionalAddress: "",
    lat: "",
    long: "",
  };
}

Address.propTypes = {
  restaurantId: PropTypes.string.isRequired,
  addressId: PropTypes.string.isRequired,
  token: PropTypes.string,
  onUpdateAddress: PropTypes.func.isRequired,
};

export default Address;
